module.exports = __webpack_public_path__ + "static/media/xcodelogo.6253dbbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/xcodelogo.png
// module id = 828
// module chunks = 0